function LPFeatures() {
    return (
    <section className="py-24 bg-background-dark relative">
        <div className="max-w-7xl mx-auto px-6">
            <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6">
                <div className="max-w-2xl">
                    <h2 className="text-accent-cyan text-sm font-bold uppercase tracking-[0.3em] mb-4">Precision Engineered</h2>
                    <h3 className="text-4xl md:text-5xl font-black text-white italic uppercase leading-none">Designed for <span className="text-primary">Victory</span></h3>
                    <p className="mt-6 text-slate-400 text-lg">Every millisecond counts. Our tools are built to give you the data you need to shave tenths off your lap time and dominate the field.</p>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="group relative bg-card-dark rounded-xl p-8 border border-white/5 hover:border-primary/50 transition-all overflow-hidden">
                    <div className="absolute top-0 right-0 p-4 opacity-5 group-hover:opacity-10 transition-opacity">
                        <span className="material-symbols-outlined text-[120px]">monitoring</span>
                    </div>

                    <div className="size-14 bg-primary/10 rounded-lg flex items-center justify-center mb-8 border border-primary/20">
                        <span className="material-symbols-outlined text-primary text-3xl">query_stats</span>
                    </div>

                    <h4 className="text-xl font-bold text-white mb-4 italic uppercase">Real-Time Telemetry</h4>
                    <p className="text-slate-400 leading-relaxed mb-6">Monitor fuel consumption, tire pressures, and brake temperatures in real-time with zero latency. Identical to real-world GT3 engineering screens.</p>
                    
                    <ul className="space-y-3">
                        <li className="flex items-center gap-2 text-sm text-slate-300"><span className="material-symbols-outlined text-accent-cyan text-sm">check_circle</span> 20Hz Update Rate</li>
                        <li className="flex items-center gap-2 text-sm text-slate-300"><span className="material-symbols-outlined text-accent-cyan text-sm">check_circle</span> Multi-Display Support</li>
                    </ul>
                </div>

                <div className="group relative bg-card-dark rounded-xl p-8 border border-white/5 hover:border-primary/50 transition-all overflow-hidden">
                    <div className="absolute top-0 right-0 p-4 opacity-5 group-hover:opacity-10 transition-opacity">
                        <span className="material-symbols-outlined text-[120px]">sync</span>
                    </div>

                    <div className="size-14 bg-primary/10 rounded-lg flex items-center justify-center mb-8 border border-primary/20">
                        <span className="material-symbols-outlined text-primary text-3xl">cloud_sync</span>
                    </div>

                    <h4 className="text-xl font-bold text-white mb-4 italic uppercase">Local Sync Software</h4>
                    <p className="text-slate-400 leading-relaxed mb-6">A lightweight background client that seamlessly pushes data to the cloud. Minimal CPU footprint so your FPS stays rock solid.</p>
                    
                    <ul className="space-y-3">
                        <li className="flex items-center gap-2 text-sm text-slate-300"><span className="material-symbols-outlined text-accent-cyan text-sm">check_circle</span> Auto-Start with ACC</li>
                        <li className="flex items-center gap-2 text-sm text-slate-300"><span className="material-symbols-outlined text-accent-cyan text-sm">check_circle</span> Direct UDP Integration</li>
                    </ul>
                </div>

                <div className="group relative bg-card-dark rounded-xl p-8 border border-white/5 hover:border-primary/50 transition-all overflow-hidden">
                    <div className="absolute top-0 right-0 p-4 opacity-5 group-hover:opacity-10 transition-opacity">
                        <span className="material-symbols-outlined text-[120px]">groups</span>
                    </div>

                    <div className="size-14 bg-primary/10 rounded-lg flex items-center justify-center mb-8 border border-primary/20">
                        <span className="material-symbols-outlined text-primary text-3xl">support_agent</span>
                    </div>

                    <h4 className="text-xl font-bold text-white mb-4 italic uppercase">Race Engineer Mode</h4>
                    <p className="text-slate-400 leading-relaxed mb-6">Share your live telemetry with friends or team engineers during endurance races. Get coaching and strategy calls in real-time.</p>
                    
                    <ul className="space-y-3">
                        <li className="flex items-center gap-2 text-sm text-slate-300"><span className="material-symbols-outlined text-accent-cyan text-sm">check_circle</span> Remote Strategy Dash</li>
                        <li className="flex items-center gap-2 text-sm text-slate-300"><span className="material-symbols-outlined text-accent-cyan text-sm">check_circle</span> Secure Team Link</li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
    );
}

export default LPFeatures;